import fpPromise from '@fingerprintjs/fingerprintjs';

/**
 * Browser-native device fingerprinting.
 * Uses @fingerprintjs/fingerprintjs to generate a stable browser fingerprint.
 */
export const generateFingerprint = async (): Promise<string> => {
    try {
        const fp = await fpPromise.load();
        const result = await fp.get();
        return result.visitorId;
    } catch (error) {
        console.error('Failed to generate fingerprint', error);
        // Fallback or bubble up error
        throw error;
    }
};
